import * as config from "../config.js";

export const getClientWorkflowGraphs = async (client_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  console.log("!!! GETTING WORKFLOWS FOR CLIENT: ", client_id);
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/workflow/client-workflows/${client_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const workflows = await response.json();
  return workflows;
};

export const getInferenceWorkflows = async () => {
  // We dispatch requestLogin to kickoff the call to the API
  console.log("!!! GETTING INFERENCE WORKFLOWS");
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/workflow/type/inference`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const workflows = await response.json();
  return workflows;
};

export const getWorkflowArchives = async (workflow) => {
  // We dispatch requestLogin to kickoff the call to the API
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/workflow/archives/${workflow.public_id}`,
    {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const results = await response.json();
  console.log("!! ARCHIVES: ", results);
  return results;
};

export const getWorkflow = async (public_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/workflow/${public_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const workflow = await response.json();
  return workflow;
};

export const getWorkflowArchive = async (public_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/workflow/archive/${public_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const workflowArchive = await response.json();
  return workflowArchive;
};

export const saveWorkflow = async (workflow) => {
  if (workflow?.archive_id) {
    console.log("!!! CAN'T SAVE ARCHIVE: ", workflow.archive_id);
    return;
  }

  // We dispatch requestLogin to kickoff the call to the API
  const method = workflow.id ? "PUT" : "POST";
  const url = workflow.id
    ? `${config.REST_SERVER_URL}/admin/workflow/${workflow.public_id}`
    : `${config.REST_SERVER_URL}/admin/workflow`;
  const response = await fetch(url, {
    method: method,
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify(workflow),
  }).catch((error) =>
    console.error(`Something was wrong. Try again: ${error}`, false)
  );

  const workflowResponse = await response.json();
  return workflowResponse;
};

export const getNode = async (public_id, archive_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  const url = archive_id
    ? `${config.REST_SERVER_URL}/admin/node/archive/${public_id}/${archive_id}`
    : `${config.REST_SERVER_URL}/admin/node/${public_id}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    }, credentials: "include",
  }).catch((error) =>
    console.error(`Something was wrong. Try again: ${error}`, false)
  );

  const node = await response.json();
  return node;
};

export const saveWorkflowGraph = async (workflowGraph, clientId) => {
  // We dispatch requestLogin to kickoff the call to the API
  workflowGraph.client_id = clientId;
  workflowGraph.graph = typeof workflowGraph.graph === "object" ? JSON.stringify(workflowGraph.graph) : workflowGraph.graph;
  const method = workflowGraph.id ? "PUT" : "POST";
  const url = workflowGraph.id
    ? `${config.REST_SERVER_URL}/admin/workflow/workflow-graph/${workflowGraph.public_id}`
    : `${config.REST_SERVER_URL}/admin/workflow/workflow-graph`;
  const response = await fetch(url, {
    method: method,
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify(workflowGraph),
  }).catch((error) =>
    console.error(`Something was wrong. Try again: ${error}`, false)
  );

  const workflowResponse = await response.json();
  return workflowResponse;
};


export const deleteWorkflowGraph = async (public_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  const url = `${config.REST_SERVER_URL}/admin/workflow/workflow-graph/${public_id}`;
  const response = await fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
  }).catch((error) =>
    console.error(`Something was wrong. Try again: ${error}`, false)
  );

  const results = await response.json();
  return results;
}

export const runWorkflowGraph = async (public_id, input) => {
  // We dispatch requestLogin to kickoff the call to the API
  const url = `${config.REST_SERVER_URL}/admin/workflow/run-workflow-graph/${public_id}`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify({ input: input }),
  }).catch((error) =>
    console.error(`Something was wrong. Try again: ${error}`, false)
  );

  const results = await response.json();
  return results;
}

export const getWorkflowGraph = async (public_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  const url = `${config.REST_SERVER_URL}/admin/workflow/workflow-graph/${public_id}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    }, credentials: "include",
  }).catch((error) =>
    console.error(`Something was wrong. Try again: ${error}`, false)
  );

  const results = await response.json();
  return results;
};
